import { render, staticRenderFns } from "./addDataPrivilegeStaff.vue?vue&type=template&id=af36bb14&scoped=true"
import script from "./addDataPrivilegeStaff.vue?vue&type=script&lang=js"
export * from "./addDataPrivilegeStaff.vue?vue&type=script&lang=js"
import style0 from "./addDataPrivilegeStaff.vue?vue&type=style&index=0&id=af36bb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af36bb14",
  null
  
)

export default component.exports